import { render, staticRenderFns } from "./ForestUsersBox.vue?vue&type=template&id=7eae974c&scoped=true&"
import script from "./ForestUsersBox.vue?vue&type=script&lang=ts&"
export * from "./ForestUsersBox.vue?vue&type=script&lang=ts&"
import style0 from "./ForestUsersBox.vue?vue&type=style&index=0&id=7eae974c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eae974c",
  null
  
)

export default component.exports